/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Milestone_EyebrowInputs */

const en_us2_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestone`)
};

const pt_br2_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco`)
};

const es_419_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logro`)
};

const pt_pt2_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco`)
};

const fr_fr2_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étape`)
};

const de_de2_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein`)
};

const it_it2_engagement_milestone_eyebrow = /** @type {(inputs: Engagement_Milestone_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traguardo`)
};

/**
* | output |
* | --- |
* | "Milestone" |
*
* @param {Engagement_Milestone_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_milestone_eyebrow = /** @type {((inputs?: Engagement_Milestone_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Milestone_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_milestone_eyebrow(inputs)
	if (locale === "es-419") return es_419_engagement_milestone_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_milestone_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_milestone_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_engagement_milestone_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_engagement_milestone_eyebrow(inputs)
	return en_us2_engagement_milestone_eyebrow(inputs)
});
export { engagement_milestone_eyebrow as "engagement.milestone_eyebrow" }